export const REF_NAME = 'TRADECOUNTERPARTY';
export const REF_PATH = 'tradecounterparty';
export const NAME = 'Trade counterparty';
